const translations = {
  de: {
    translation: {
      register: {
        title: 'Registrieren',
        register: 'Registrieren',
        username: 'Benutzername',
        email: 'E-Mail',
        password: 'Passwort',
        passwordRepeat: 'Passwort wiederholen',
        loginMessage: 'Bereits ein Konto? Anmelden',
        failMessage: 'Registrierung fehlgeschlagen. Bitte versuche es erneut.',
        fillFields: 'Bitte alle Felder ausfüllen.',
        passwordMismatch: 'Die Passwörter stimmen nicht überein',
      },
      login: {
        title: 'Anmelden',
        username: 'Benutzername',
        password: 'Passwort',
        login: 'Anmelden',
        registerMessage: 'Noch keinen Account? Registrieren',
        failMessage: 'Anmeldung fehlgeschlagen. Überprüfe deine Anmeldedaten.',
        fillFields: 'Bitte alle Felder ausfüllen.',
      },
      navbar: {
        appName: 'Swiss Emergency Map',
        addPOI: 'POI Hinzufügen',
        municipality: 'Gemeinde bearbeiten',
      },
      poiForm: {
        title: 'POI hinzufügen',
        name: 'Name',
        description: 'Beschreibung',
        category: 'Kategorie',
        selectCategory: 'Kategorie auswählen',
        addNewCategory: 'Neue Kategorie hinzufügen',
        addCategory: 'Kategorie hinzufügen',
        addFiles: 'Dateien hinzufügen',
        addFile: 'Datei hinzufügen',
        noSelectedFile: 'Keinen File ausgewählt',
        browse: 'Durchsuchen',
        save: 'Speichern',
        delete: 'Löschen',
        cancel: 'Abbrechen',
        confirmDelete: 'Möchten Sie diesen POI wirklich löschen?',
        deletePoi: 'POI löschen',
        missingName: 'Geben Sie einen Namen an.',
        missingCategory: 'Geben Sie eine Kategorie an.',
        missingMunicipality:
          'Sie müssen einer Gemeinde zugehören um einen Punkt zu erstellen',
        toMunicipality: 'Zur Gemeinde-Seite',
        cancelAction: 'Abbrechen bestätigen',
        confirmCancel:
          'Alle Änderungen gehen verloren. Sind Sie sicher, dass Sie fortfahren möchten?',
        no: 'Nein',
        yes: 'Ja',
        searchIcons: 'Icons suchen',
        deletionSuccessful: 'POI erfolgreich gelöscht',
        additionSuccessful: 'POI erfolgreich gespeichert',
      },
      municipality: {
        title: 'Gemeinde hinzufügen',
        addUser: 'Benutzer Hinzufügen',
        selectUser: 'Benutzer suchen',
        addMunicipality: 'Gemeinde Hinzufügen',
        userInMunicipality: 'Benutzer in dieser Gemeinde',
        create: 'Gemeinde Erstellen',
        remove: 'Entfernen',
        abort: 'Abbrechen',
        name: 'Name der Gemeinde',
        addLogo: 'Logo hinzufügen',
        noLogo: 'Kein Logo ausgewählt',
        browse: 'Durchsuchen',
        save: 'Speichern',
        removeUser: 'Benutzer Entfernen',
        noUser: 'In Ihrer Gemeinde sind nur Sie.',
        leaveMunicipality: 'Gemeinde verlassen',
        leave: 'Verlassen',
        edit: 'Editieren',
        back: 'Zurück',
        confirmationText:
          'Möchtest du den Benutzer <strong>{{username}}</strong> wirklich aus der Gemeinde entfernen?',
        confirmationTextCurrentUser:
          'Wollen Sie wirklich die Gemeinde verlassen?',
        missingName: 'Geben Sie einen Namen an.',
        invalidLogoType:
          'Bitte wählen Sie eine Bilddatei aus (.jpg, .jpeg, .png, .gif, .webp, .bmp).',
        invalidLogoSize: 'Das Logo darf maximal 1 MB groß sein.',
        viewer: 'Betrachter',
        editor: 'Bearbeiter',
        manager: 'Verwalter',
        admin: 'Administrator',
        selectRole: 'Rolle auswählen',
        notInMunicipality: 'Sie gehören keiner Gemeinde an.',
        editRole: 'Rolle bearbeiten',
        userAdded: 'Benutzer erfolgreich hinzugefügt.',
        userRemoved: 'Benutzer erfolgreich entfernt.',
        leftMunicipality: 'Gemeinde erfolgreich verlassen.',
        roleUpdated: 'Benutzerrolle erfolgreich aktualisiert.',
      },
      attributions: {
        fixTheMap: 'Verbessere diese Karte',
        OSM: '© OpenStreetMap Mitwirkende',
      },
      categoriesWindow: {
        categories: 'Kategorien',
        noCategory: 'Keine Kategorie verfügbar',
        public: 'Öffentlich',
        confidential: 'Vertraulich',
      },
      infoWindow: {
        files: 'Dateien',
        save: 'Editieren',
      },
      search: {
        searchForLocation: 'Nach einem Ort suchen',
        noName: 'Ohne Titel',
        noResults: 'Keine Ergebnisse gefunden',
      },
      success: {
        title: 'Erfolgreich',
      },
      error: {
        title: 'Fehler',
        searchQuery: 'Bitte gib eine gültige Anfrage ein',
        failedToFetch: 'Abrufen fehlgeschlagen: {{error}}',
        failedToFetchSearchResults:
          'Abrufen der Suchergebnisse fehlgeschlagen, Ergebnisse können unvollständig sein',
        unauthorized: 'Sie haben keine Berechtigung, diese Aktion auszuführen.',
      },
    },
  },
  fr: {
    translation: {
      register: {
        title: 'Créer un compte',
        register: 'Créer un compte',
        username: 'Nom d’utilisateur',
        email: 'E-mail',
        password: 'Mot de passe',
        passwordRepeat: 'Répétez le mot de passe',
        loginMessage: 'Déjà un compte ? Connectez-vous',
        failMessage: 'Échec de l’inscription. Veuillez réessayer.',
        fillFields: 'Veuillez remplir tous les champs.',
        passwordMismatch: 'Les mots de passe ne correspondent pas.',
      },
      login: {
        title: 'Se connecter',
        username: 'Nom d’utilisateur',
        password: 'Mot de passe',
        login: 'Se connecter',
        registerMessage: 'Pas encore de compte ? Créez un compte',
        failMessage:
          'Échec de la connexion. Veuillez vérifier vos identifiants.',
        fillFields: 'Veuillez remplir tous les champs.',
      },
      navbar: {
        appName: 'Swiss Emergency Map',
        addPOI: 'Ajouter un POI',
        municipality: 'Modifier la municipalité',
      },
      poiForm: {
        title: 'Ajouter un POI',
        name: 'Nom',
        description: 'Description',
        category: 'Catégorie',
        selectCategory: 'Choisir une catégorie',
        addNewCategory: 'Ajouter une nouvelle catégorie',
        addCategory: 'Ajouter une catégorie',
        addFiles: 'Ajouter des fichiers',
        addFile: 'Ajouter un fichier',
        noSelectedFile: 'Aucun fichier sélectionné',
        browse: 'Parcourir',
        save: 'Enregistrer',
        delete: 'Supprimer',
        cancel: 'Annuler',
        confirmDelete: 'Voulez-vous vraiment supprimer ce POI ?',
        deletePoi: 'Supprimer le POI',
        missingName: 'Veuillez indiquer un nom.',
        missingCategory: 'Veuillez indiquer une catégorie.',
        missingMunicipality:
          'Vous devez appartenir à une commune pour créer un point',
        toMunicipality: 'Aller à la page de la commune',
        cancelAction: 'Confirmation de l’annulation',
        confirmCancel:
          'Toutes les modifications seront perdues. Êtes-vous sûr de vouloir continuer?',
        no: 'Non',
        yes: 'Oui',
        searchIcons: 'Rechercher des icônes',
        deletionSuccessful: 'POI supprimé avec succès',
        additionSuccessful: 'POI enregistré avec succès',
      },
      municipality: {
        title: 'Ajouter une commune',
        addUser: 'Ajouter un utilisateur',
        selectUser: 'Rechercher un utilisateur',
        addMunicipality: 'Ajouter une commune',
        userInMunicipality: 'Utilisateurs dans cette commune',
        create: 'Créer une commune',
        remove: 'Supprimer',
        abort: 'Annuler',
        name: 'Nom de la commune',
        addLogo: 'Ajouter un logo',
        noLogo: 'Aucun logo sélectionné',
        browse: 'Parcourir',
        save: 'Enregistrer',
        removeUser: 'Supprimer l’utilisateur',
        noUser: 'Vous êtes le seul utilisateur dans votre commune.',
        edit: 'Modifier',
        back: 'Retour',
        leaveMunicipality: 'Quitter la commune',
        leave: 'Quitter',
        confirmationText:
          'Voulez-vous vraiment supprimer l’utilisateur <strong>{{username}}</strong> de la commune ?',
        confirmationTextCurrentUser:
          'Voulez-vous vraiment quitter la municipalité ?',
        missingName: 'Veuillez indiquer un nom.',
        invalidLogoType:
          'Veuillez sélectionner une image (.jpg, .jpeg, .png, .gif, .webp, .bmp).',
        invalidLogoSize: 'Le logo doit faire moins de 1 Mo.',
        viewer: 'Visualiseur',
        editor: 'Éditeur',
        manager: 'Gestionnaire',
        admin: 'Administrateur',
        selectRole: 'Sélectionner un rôle',
        notInMunicipality: 'Vous ne faites pas partie d’une commune.',
        editRole: 'Modifier le rôle',
        userAdded: 'Utilisateur ajouté avec succès.',
        userRemoved: 'Utilisateur supprimé avec succès.',
        leftMunicipality: 'Municipalité quittée avec succès.',
        roleUpdated: 'Rôle utilisateur mis à jour avec succès.',
      },
      attributions: {
        fixTheMap: 'Améliorer cette carte',
        OSM: '© Contributeurs OpenStreetMap',
      },
      categoriesWindow: {
        categories: 'Catégories',
        noCategory: 'Aucune catégorie disponible',
        public: 'Publique',
        confidential: 'Confidentiel',
      },
      infoWindow: {
        files: 'Fichiers',
        edit: 'Modifier',
      },
      search: {
        searchForLocation: 'Rechercher un lieu',
        noName: 'Sans titre',
        noResults: 'Aucun résultat trouvé',
      },
      success: {
        title: 'Succès',
      },
      error: {
        title: 'Erreur',
        searchQuery: 'Veuillez saisir une requête valide',
        failedToFetch: 'Échec de la récupération : {{error}}',
        failedToFetchSearchResults:
          'Échec de la récupération des résultats de recherche, les résultats peuvent être incomplets',
        unauthorized: 'Vous n’avez pas la permission d’effectuer cette action.',
      },
    },
  },
  en: {
    translation: {
      register: {
        title: 'Register',
        register: 'Register',
        username: 'Username',
        email: 'Email',
        password: 'Password',
        passwordRepeat: 'Repeat Password',
        loginMessage: 'Already have an account? Log in',
        failMessage: 'Registration failed. Please try again.',
        fillFields: 'Please fill out all fields.',
        passwordMismatch: 'Passwords do not match.',
      },
      login: {
        title: 'Log in',
        username: 'Username',
        password: 'Password',
        login: 'Log in',
        registerMessage: 'Don’t have an account? Register',
        failMessage: 'Login failed. Please check your credentials.',
        fillFields: 'Please fill out all fields.',
      },
      navbar: {
        appName: 'Swiss Emergency Map',
        addPOI: 'Add POI',
        municipality: 'Edit Municipality',
      },
      poiForm: {
        title: 'Add POI',
        name: 'Name',
        description: 'Description',
        category: 'Category',
        selectCategory: 'Select Category',
        addNewCategory: 'Add New Category',
        addCategory: 'Add Category',
        addFiles: 'Add Files',
        addFile: 'Add File',
        noSelectedFile: 'No file selected',
        browse: 'Browse',
        save: 'Save',
        delete: 'Delete',
        cancel: 'Cancel',
        confirmDelete: 'Do you really want to delete this POI?',
        deletePoi: 'Delete POI',
        missingName: 'Please provide a name.',
        missingCategory: 'Please select a category.',
        missingMunicipality:
          'You must belong to a municipality to create a point.',
        toMunicipality: 'Go to Municipality Page',
        cancelAction: 'Cancel Confirmation',
        confirmCancel:
          'All changes will be lost. Are you sure you want to proceed?',
        no: 'Back',
        yes: 'Proceed',
        searchIcons: 'Search Icons',
        deletionSuccessful: 'POI deleted successfully',
        additionSuccessful: 'POI saved successfully',
      },
      municipality: {
        title: 'Add Municipality',
        addUser: 'Add User',
        selectUser: 'Search for User',
        addMunicipality: 'Add Municipality',
        userInMunicipality: 'Users in this Municipality',
        create: 'Create Municipality',
        remove: 'Remove',
        abort: 'Cancel',
        name: 'Municipality Name',
        addLogo: 'Add Logo',
        noLogo: 'No logo selected',
        browse: 'Browse',
        save: 'Save',
        removeUser: 'Remove User',
        noUser: 'You are the only user in your municipality.',
        leaveMunicipality: 'Leave Municipality',
        leave: 'Leave',
        edit: 'Edit',
        back: 'Back',
        confirmationText:
          'Do you really want to remove the user <strong>{{username}}</strong> from the municipality?',
        confirmationTextCurrentUser:
          'Do you really want to leave the municipality?',
        missingName: 'Please provide a name.',
        invalidLogoType:
          'Please select an image file (.jpg, .jpeg, .png, .gif, .webp, .bmp).',
        invalidLogoSize: 'Logo must be smaller than 1 MB.',
        viewer: 'Viewer',
        editor: 'Editor',
        manager: 'Manager',
        admin: 'Administrator',
        selectRole: 'Select Role',
        notInMunicipality: 'You are not part of a municipality.',
        editRole: 'Edit Role',
        userAdded: 'User added successfully.',
        userRemoved: 'User removed successfully.',
        leftMunicipality: 'Municipality left successfully.',
        roleUpdated: 'User role updated successfully.',
      },
      attributions: {
        fixTheMap: 'Improve this map',
        OSM: '© OpenStreetMap contributors',
      },
      categoriesWindow: {
        categories: 'Categories',
        noCategory: 'No category available',
        public: 'Public',
        confidential: 'Confidential',
      },
      infoWindow: {
        files: 'Files',
        edit: 'Edit',
      },
      search: {
        searchForLocation: 'Search for a location',
        noName: 'No Name',
        noResults: 'No results found',
      },
      error: {
        title: 'Error',
        searchQuery: 'Please enter a valid query',
        failedToFetch: 'Failed to fetch: {{error}}',
        failedToFetchSearchResults:
          'Failed to fetch search results, results may be incomplete',
        unauthorized: 'You do not have permission to perform this action.',
      },
      success: {
        title: 'Success',
      },
    },
  },
  nl: {
    translation: {
      register: {
        title: 'Registreren',
        register: 'Registreren',
        username: 'Gebruikersnaam',
        email: 'E-mail',
        password: 'Wachtwoord',
        passwordRepeat: 'Wachtwoord herhalen',
        loginMessage: 'Heb je al een account? Log in',
        failMessage: 'Registratie mislukt. Probeer het opnieuw.',
        fillFields: 'Vul alle velden in.',
        passwordMismatch: 'Wachtwoorden komen niet overeen.',
      },
      login: {
        title: 'Inloggen',
        username: 'Gebruikersnaam',
        password: 'Wachtwoord',
        login: 'Inloggen',
        registerMessage: 'Nog geen account? Registreer',
        failMessage: 'Inloggen mislukt. Controleer je gegevens.',
        fillFields: 'Vul alle velden in.',
      },
      navbar: {
        appName: 'Swiss Emergency Map',
        addPOI: 'POI toevoegen',
        municipality: 'Gemeente bewerken',
      },
      poiForm: {
        title: 'POI toevoegen',
        name: 'Naam',
        description: 'Beschrijving',
        category: 'Categorie',
        selectCategory: 'Selecteer categorie',
        addNewCategory: 'Nieuwe categorie toevoegen',
        addCategory: 'Categorie toevoegen',
        addFiles: 'Bestanden toevoegen',
        addFile: 'Bestand toevoegen',
        noSelectedFile: 'Geen bestand geselecteerd',
        browse: 'Bladeren',
        save: 'Opslaan',
        delete: 'Verwijderen',
        cancel: 'Annuleren',
        confirmDelete: 'Wil je deze POI echt verwijderen?',
        deletePoi: 'POI verwijderen',
        missingName: 'Vul een naam in.',
        missingCategory: 'Selecteer een categorie.',
        missingMunicipality:
          'Je moet bij een gemeente horen om een punt aan te maken.',
        toMunicipality: 'Ga naar de gemeentepagina',
        cancelAction: 'Annulering bevestigen',
        confirmCancel:
          'Alle wijzigingen gaan verloren. Weet je zeker dat je wilt doorgaan?',
        no: 'Terug',
        yes: 'Doorgaan',
        searchIcons: 'Zoek iconen',
        deletionSuccessful: 'POI succesvol verwijderd',
        additionSuccessful: 'POI succesvol bijgewerkt',
      },
      municipality: {
        title: 'Gemeente toevoegen',
        addUser: 'Gebruiker toevoegen',
        selectUser: 'Zoeken naar gebruiker',
        addMunicipality: 'Gemeente toevoegen',
        userInMunicipality: 'Gebruikers in deze gemeente',
        create: 'Gemeente aanmaken',
        remove: 'Verwijderen',
        abort: 'Annuleren',
        name: 'Naam gemeente',
        addLogo: 'Logo toevoegen',
        noLogo: 'Geen logo geselecteerd',
        browse: 'Bladeren',
        save: 'Opslaan',
        removeUser: 'Gebruiker verwijderen',
        noUser: 'Je bent de enige gebruiker in je gemeente.',
        leaveMunicipality: 'Gemeente verlaten',
        leave: 'Verlaten',
        edit: 'Bewerken',
        back: 'Terug',
        confirmationText:
          'Weet je zeker dat je gebruiker <strong>{{username}}</strong> wilt verwijderen uit de gemeente?',
        confirmationTextCurrentUser:
          'Weet je zeker dat je de gemeente wilt verlaten?',
        missingName: 'Vul een naam in.',
        invalidLogoType:
          'Selecteer een afbeeldingsbestand (.jpg, .jpeg, .png, .gif, .webp, .bmp).',
        invalidLogoSize: 'Het logo moet kleiner zijn dan 1 MB.',
        viewer: 'Gebruiker',
        editor: 'Bewerker',
        manager: 'Beheerder',
        admin: 'Administrator',
        selectRole: 'Selecteer rol',
        notInMunicipality: 'Je maakt geen deel uit van een gemeente.',
        editRole: 'Bewerk rol',
        userAdded: 'Gebruiker succesvol toegevoegd.',
        userRemoved: 'Gebruiker succesvol verwijderd.',
        leftMunicipality: 'Gemeente succesvol verlaten.',
        roleUpdated: 'Gebruikersrol succesvol bijgewerkt.',
      },
      attributions: {
        fixTheMap: 'Verbeter deze kaart',
        OSM: '© OpenStreetMap-bijdragers',
      },
      categoriesWindow: {
        categories: 'Categorieën',
        noCategory: 'Geen categorie beschikbaar',
        public: 'Openbaar',
        confidential: 'Vertrouwelijk',
      },
      infoWindow: {
        files: 'Bestanden',
        edit: 'Bewerken',
      },
      search: {
        searchForLocation: 'Zoek naar een locatie',
        noName: 'Zonder titel',
        noResults: 'Geen resultaten gevonden',
      },
      success: {
        title: 'Succes',
      },
      error: {
        title: 'Fout',
        searchQuery: 'Voer een geldige zoekopdracht in',
        failedToFetch: 'Ophalen mislukt: {{error}}',
        failedToFetchSearchResults:
          'Ophalen zoekresultaten mislukt, resultaten kunnen onvolledig zijn',
        unauthorized: 'Je hebt geen toestemming om deze actie uit te voeren.',
      },
    },
  },
};

export default translations;
